import { Toaster as Sonner, type ToasterProps } from 'sonner';
import type { ThemeId } from '@core';

type AppToasterProps = ToasterProps & {
  themeId: ThemeId;
};

const Toaster = ({ themeId, ...props }: AppToasterProps) => {
  return (
    <Sonner
      theme={themeId}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
